import { render, staticRenderFns } from "./CustomerNav.vue?vue&type=template&id=e24e6290&scoped=true&lang=pug"
import script from "./CustomerNav.vue?vue&type=script&lang=js"
export * from "./CustomerNav.vue?vue&type=script&lang=js"
import style0 from "./CustomerNav.vue?vue&type=style&index=0&id=e24e6290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e6290",
  null
  
)

export default component.exports